import {useApp} from 'components/App/AppContext';

const useCurrentUserSelector = () => {
  const {user} = useApp();
  return user;
};

export default useCurrentUserSelector;
